{
	"locales": {
		"de-DE": {
			"display": "Deutsch",
			"sort": "deutsch",
			"beta": false
		},
		"en-AU": {
			"display": "English (Australia)",
			"sort": "english (au)",
			"beta": false
		},
		"en-CA": {
			"display": "English (Canada)",
			"sort": "english (ca)",
			"beta": false
		},
		"en-GB": {
			"display": "English (United Kingdom)",
			"sort": "english (uk)",
			"beta": false
		},
		"en-IN": {
			"display": "English (India)",
			"sort": "english (in)",
			"beta": false
		},
		"en-US": {
			"display": "English (United States)",
			"sort": "english (us)",
			"beta": false
		},
		"es-ES": {
			"display": "Español (España)",
			"sort": "español (es)",
			"beta": false
		},
		"es-419": {
			"display": "Español (Latinoamérica)",
			"sort": "español (latinoamérica)",
			"beta": false
		},
		"es-AR": {
			"display": "Español (Argentina)",
			"sort": "español (ar)",
			"beta": false
		},
		"fr-FR": {
			"display": "Français",
			"sort": "français",
			"beta": false
		},
		"hi-IN": {
			"display": "हिन्दी",
			"sort": "hindī",
			"beta": false
		},
		"id-ID": {
			"display": "Bahasa Indonesia",
			"sort": "indonesia",
			"beta": false
		},
		"it-IT": {
			"display": "Italiano",
			"sort": "italiano",
			"beta": false
		},
		"ja-JP": {
			"display": "日本語",
			"sort": "nihongo",
			"beta": false
		},
		"ko-KR": {
			"display": "[beta] 한국어",
			"sort": "zzz-hangugŏ",
			"beta": true
		},
		"pt-BR": {
			"display": "Português (Brasil)",
			"sort": "português (brasil)",
			"beta": false
		},
		"ru-RU": {
			"display": "Русский",
			"sort": "russkiy",
			"beta": false
		},
		"th-TH": {
			"display": "ภาษาไทย",
			"sort": "thai",
			"beta": false
		},
		"tr-TR": {
			"display": "Türkçe",
			"sort": "türkçe",
			"beta": false
		}
	},
	"countries": {
		"A1": "en-US",
		"A2": "en-US",
		"AC": "en-GB",
		"AD": "es-ES",
		"AE": "en-US",
		"AF": "en-US",
		"AG": "en-GB",
		"AI": "en-GB",
		"AL": "en-US",
		"AM": "ru-RU",
		"AN": "en-US",
		"AO": "en-US",
		"AP": "en-US",
		"AQ": "en-US",
		"AR": "es-AR",
		"AS": "en-US",
		"AT": "de-DE",
		"AU": "en-AU",
		"AW": "en-US",
		"AX": "en-US",
		"AZ": "tr-TR",
		"BA": "en-US",
		"BB": "en-GB",
		"BD": "en-GB",
		"BE": "en-US",
		"BF": "fr-FR",
		"BG": "en-US",
		"BH": "en-US",
		"BI": "fr-FR",
		"BJ": "fr-FR",
		"BL": "fr-FR",
		"BM": "en-GB",
		"BN": "id-ID",
		"BO": "es-419",
		"BQ": "en-US",
		"BR": "pt-BR",
		"BS": "en-US",
		"BT": "en-US",
		"BV": "en-US",
		"BW": "en-GB",
		"BY": "ru-RU",
		"BZ": "en-GB",
		"CA": {
		  "default": "en-CA",
		  "QC": "fr-FR"
		},
		"CC": "en-AU",
		"CD": "fr-FR",
		"CE": "es-ES",
		"CF": "fr-FR",
		"CG": "fr-FR",
		"CH": "en-US",
		"CI": "fr-FR",
		"CK": "en-AU",
		"CL": "es-419",
		"CM": "fr-FR",
		"CN": "en-US",
		"CO": "es-419",
		"CP": "en-AU",
		"CQ": "en-GB",
		"CR": "es-419",
		"CS": "en-US",
		"CU": "es-419",
		"CV": "en-US",
		"CW": "en-US",
		"CX": "en-AU",
		"CY": "en-US",
		"CZ": "en-US",
		"DE": "de-DE",
		"DG": "en-GB",
		"DJ": "fr-FR",
		"DK": "en-US",
		"DM": "en-GB",
		"DO": "es-419",
		"DZ": "fr-FR",
		"EA": "es-ES",
		"EC": "es-419",
		"EE": "en-US",
		"EG": "en-US",
		"EH": "es-ES",
		"ER": "en-US",
		"ES": "es-ES",
		"ET": "en-US",
		"EU": "en-US",
		"FI": "en-US",
		"FJ": "en-US",
		"FK": "en-GB",
		"FM": "en-US",
		"FO": "en-US",
		"FR": "fr-FR",
		"GA": "fr-FR",
		"GB": "en-GB",
		"GD": "en-US",
		"GE": "en-US",
		"GF": "fr-FR",
		"GG": "en-GB",
		"GH": "en-US",
		"GI": "en-GB",
		"GL": "en-US",
		"GM": "en-US",
		"GN": "fr-FR",
		"GP": "fr-FR",
		"GQ": "es-ES",
		"GR": "en-US",
		"GS": "en-GB",
		"GT": "es-419",
		"GU": "en-US",
		"GW": "fr-FR",
		"GY": "en-GB",
		"HK": "en-GB",
		"HM": "en-AU",
		"HN": "es-419",
		"HR": "en-US",
		"HT": "fr-FR",
		"HU": "en-US",
		"IC": "es-ES",
		"ID": "id-ID",
		"IE": "en-GB",
		"IL": "en-US",
		"IM": "en-GB",
		"IN": "en-IN",
		"IO": "en-GB",
		"IQ": "en-US",
		"IR": "en-US",
		"IS": "en-US",
		"IT": "it-IT",
		"JE": "en-GB",
		"JM": "en-GB",
		"JO": "en-US",
		"JP": "ja-JP",
		"KE": "en-GB",
		"KG": "ru-RU",
		"KH": "en-US",
		"KI": "en-AU",
		"KM": "fr-FR",
		"KN": "en-GB",
		"KP": "en-US",
		"KR": "en-US",
		"KV": "en-US",
		"KW": "en-US",
		"KY": "en-GB",
		"KZ": "ru-RU",
		"LA": "en-US",
		"LB": "en-US",
		"LC": "en-GB",
		"LI": "de-DE",
		"LK": "en-GB",
		"LR": "en-GB",
		"LS": "en-GB",
		"LT": "en-US",
		"LU": "fr-FR",
		"LV": "en-US",
		"LY": "en-US",
		"MA": "fr-FR",
		"MC": "fr-FR",
		"MD": "en-US",
		"ME": "en-US",
		"MF": "fr-FR",
		"MG": "fr-FR",
		"MH": "en-US",
		"MK": "en-US",
		"ML": "fr-FR",
		"MM": "en-US",
		"MN": "en-US",
		"MO": "en-US",
		"MP": "en-US",
		"MQ": "fr-FR",
		"MR": "fr-FR",
		"MS": "en-GB",
		"MT": "en-US",
		"MU": "en-GB",
		"MV": "en-GB",
		"MW": "en-GB",
		"MX": "es-419",
		"MY": "en-GB",
		"MZ": "en-US",
		"NA": "en-GB",
		"NC": "fr-FR",
		"NE": "fr-FR",
		"NF": "en-AU",
		"NG": "en-GB",
		"NI": "es-419",
		"NL": "en-US",
		"NO": "en-US",
		"NP": "en-US",
		"NR": "en-AU",
		"NT": "en-US",
		"NU": "en-AU",
		"NZ": "en-AU",
		"OM": "en-US",
		"PA": "es-419",
		"PE": "es-419",
		"PF": "fr-FR",
		"PG": "en-AU",
		"PH": "en-US",
		"PK": "en-GB",
		"PL": "en-US",
		"PM": "fr-FR",
		"PN": "en-AU",
		"PR": "es-419",
		"PS": "en-US",
		"PT": "pt-BR",
		"PW": "en-US",
		"PY": "es-AR",
		"QA": "en-US",
		"RE": "fr-FR",
		"RO": "en-US",
		"RS": "en-US",
		"RU": "ru-RU",
		"RW": "en-GB",
		"SA": "en-US",
		"SB": "en-AU",
		"SC": "fr-FR",
		"SD": "en-US",
		"SE": "en-US",
		"SG": "en-GB",
		"SH": "en-GB",
		"SI": "en-US",
		"SJ": "en-US",
		"SK": "en-US",
		"SL": "en-GB",
		"SM": "it-IT",
		"SN": "fr-FR",
		"SO": "en-US",
		"SR": "en-US",
		"SS": "en-US",
		"ST": "en-US",
		"SU": "ru-RU",
		"SV": "es-419",
		"SX": "en-US",
		"SY": "en-US",
		"SZ": "en-GB",
		"TA": "en-GB",
		"TC": "en-GB",
		"TD": "fr-FR",
		"TF": "fr-FR",
		"TG": "fr-FR",
		"TH": "th-TH",
		"TJ": "en-US",
		"TK": "en-AU",
		"TL": "en-US",
		"TM": "en-US",
		"TN": "fr-FR",
		"TO": "en-US",
		"TR": "tr-TR",
		"TT": "en-GB",
		"TV": "en-AU",
		"TW": "en-US",
		"TZ": "en-GB",
		"UA": "en-US",
		"UG": "en-GB",
		"UK": "en-GB",
		"UM": "en-US",
		"US": "en-US",
		"UY": "es-AR",
		"UZ": "en-US",
		"VA": "en-US",
		"VC": "en-GB",
		"VE": "es-419",
		"VG": "en-GB",
		"VI": "en-US",
		"VN": "en-US",
		"VU": "en-AU",
		"WF": "fr-FR",
		"WS": "en-US",
		"XK": "en-US",
		"YE": "en-US",
		"YT": "fr-FR",
		"ZA": "en-GB",
		"ZM": "en-GB",
		"ZW": "en-GB"
	},
	"langs": {
		"de": "de-DE",
		"en": {
			"default": "en-US",
			"AC": "en-GB",
			"AU": "en-AU",
			"BD": "en-GB",
			"BM": "en-GB",
			"CA": "en-CA",
			"FK": "en-GB",
			"GB": "en-GB",
			"GG": "en-GB",
			"GI": "en-GB",
			"HK": "en-GB",
			"HM": "en-AU",
			"IE": "en-GB",
			"IM": "en-GB",
			"IN": "en-IN",
			"IO": "en-GB",
			"JE": "en-GB",
			"KY": "en-GB",
			"LC": "en-GB",
			"LK": "en-GB",
			"LR": "en-GB",
			"MS": "en-GB",
			"MU": "en-GB",
			"MV": "en-GB",
			"MW": "en-GB",
			"MY": "en-GB",
			"NA": "en-GB",
			"NF": "en-AU",
			"NG": "en-GB",
			"NR": "en-AU",
			"NU": "en-AU",
			"NZ": "en-AU",
			"PG": "en-AU",
			"PK": "en-GB",
			"PN": "en-AU",
			"RW": "en-GB",
			"SG": "en-GB",
			"SL": "en-GB",
			"SZ": "en-GB",
			"TA": "en-GB",
			"TC": "en-GB",
			"TT": "en-GB",
			"TV": "en-AU",
			"TZ": "en-GB",
			"UG": "en-GB",
			"UK": "en-GB",
			"VA": "en-US",
			"VC": "en-GB",
			"VG": "en-GB",
			"VU": "en-AU",
			"ZA": "en-GB",
			"ZM": "en-GB"
		},
		"es": {
			"default": "es-ES",
			"AR": "es-AR",
			"BO": "es-419",
			"CL": "es-419",
			"CO": "es-419",
			"CR": "es-419",
			"CU": "es-419",
			"DO": "es-419",
			"EC": "es-419",
			"GT": "es-419",
			"HN": "es-419",
			"MX": "es-419",
			"NI": "es-419",
			"PA": "es-419",
			"PE": "es-419",
			"PR": "es-419",
			"PY": "es-AR",
			"SV": "es-419",
			"US": "es-419",
			"UY": "es-AR",
			"VE": "es-419"
		},
		"fr": "fr-FR",
		"hi": "hi-IN",
		"id": "id-ID",
		"it": "it-IT",
		"ja": "ja-JP",
		"ko": "ko-KR",
		"pt": "pt-BR",
		"ru": "ru-RU",
		"th": "th-TH",
		"tr": "tr-TR"
	},
	"fallback": "en-US"
}
